import axios from "axios";


export function createCategory(category) {
  return new Promise(async (resolve) => {
  const response = await axios.post(
   process.env.REACT_APP_BASE_API  +"/category/add-category",
    category
  );
      const data = response.data;
    resolve({ data });
  });
}

export function fetchCategory() {
  return new Promise(async (resolve) => {
    const response = await axios.get(
      process.env.REACT_APP_BASE_API+ "/category/get-category"
    );
    const data = response.data;
    resolve({ data });
  });
}

export function fetchCategoryByAdmin() {
  return new Promise(async (resolve) => {
    const response = await axios.get(
      process.env.REACT_APP_BASE_API+"/category/get-category-admin"
    );
    const data = response.data;
    resolve({ data });
  });
}

export function fetchCategoryById(categoryId) {
  return new Promise(async (resolve) => {
    const response = await axios.post(
      process.env.REACT_APP_BASE_API+"/category/get-category-by-id",
      {
        categoryId: categoryId,
      }
    );

    const data = response.data;
    resolve({ data });
  });
}

export function updateCategory(categoryId, newCategory) {
  return new Promise(async (resolve) => {
    const response = await axios.put( process.env.REACT_APP_BASE_API+"/category/update-category", {
      categoryId: categoryId,
      categoryName: newCategory.categoryName,
      categoryImage: newCategory.categoryImage,
      categoryDescription: newCategory.categoryDescription,
    });
    const data = response.data;
    resolve({ data });
  });
}

export function deleteCategoryById(categoryId) {
  return new Promise(async (resolve) => {
   const response = await axios.patch(
     `${ process.env.REACT_APP_BASE_API}/category/delete-category/${categoryId}`
   );
    const data = response.data;
    resolve({ data });
  });
}
export function toggleCategoryStatus(categoryId) {
  return new Promise(async (resolve) => {
   const response = await axios.patch(
     `${ process.env.REACT_APP_BASE_API}/category/toggle-category-status/${categoryId}`
   );
     const data = response.data;
    resolve({ data });
  });
}
